import React from 'react'
import { Modal, Table } from 'react-bootstrap';

const ViewRecordObjectData = (props) => {
    const toggle = () => {
        props?.close?.();
    };

    const record = props?.activeModelRecordData;

    return (
        <Modal show={props?.showModel} onHide={toggle} size="md">
            <Modal.Header style={{ borderBottom: "none" }} closeButton>
                <Modal.Title>{props?.title || "Record Details"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {record ? (
                    <Table striped bordered hover size="sm">
                        <tbody>
                            {Object.entries(record || {})?.map(([key, value]) => (
                                <tr key={key}>
                                    <td className='p-2'><strong>{key}</strong></td>
                                    <td className='p-2'>
                                        {
                                            typeof value === "object" ? (
                                                <pre className='m-0'>
                                                    {JSON.stringify(value, null, 2)}
                                                </pre>
                                            ) : (
                                                <span>{String(value)}</span>
                                            )
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>No data available</p>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ViewRecordObjectData;
